export const OUTSIDE_AID_TYPES = [
  'Federal Grant',
  'Pell Grant',
  'State Grants',
  'Subsidized Loan',
  'Unsubsidized Loan',
];

export const FUND_TYPES = {
  STACK: 'Stack',
  TOPPER: 'Topper'
};

export const DEFAULT_OUTSIDE_AID_STATE = {
  0: false, // Federal Grant
  1: false, // Pell Grant
  2: false, // State Grants
  3: false, // Subsidized Loan
  4: false, // Unsubsidized Loan
}; 